import { vaultPostRequest } from '../helpers';
import type { IDeleteCropRequest } from './delete-crop-request';
import type { IDeleteCropResponse } from './delete-crop-response';
import { deleteCropResponseSchema } from './delete-crop-response';

export async function deleteCropApi(body: IDeleteCropRequest): Promise<IDeleteCropResponse> {
  return vaultPostRequest({ path: '/crop/delete', body, schema: deleteCropResponseSchema });
}
